import { Group, Text, Button } from '@mantine/core';

interface DataTableTokenPaginationProps {
    totalCount: string;
    nextToken: string | null;
    handleLoadMore: () => void;
    loading?: boolean;
}

export const DataTableTokenPagination = ({
    totalCount,
    nextToken,
    handleLoadMore,
    loading = false
}: DataTableTokenPaginationProps) => {
    return (
        <Group justify="space-between" p="md">
            <Text size="sm" c="dimmed">
                Total records: {totalCount}
            </Text>
            <Button 
                onClick={handleLoadMore} 
                variant="light" 
                loading={loading} 
                disabled={!nextToken || loading}
            >
                {nextToken ? 'Load More' : 'All Records Loaded'}
            </Button>
        </Group>
    );
};
